import { ReactElement } from 'react';
import { useEntity, EntityActions, TabNav } from 'components';
import { bookingActions } from 'modules/invoicing/expenses';
import permissions from 'modules/invoicing/expenses/permissions';
import { PaymentStateBadge, InvoiceSource, useNavLinks } from 'modules/invoicing/common';
import type { Expense } from 'modules/invoicing/expenses/types';

import { Box, Button, ButtonGroup, Dialog, DialogContent, DialogTrigger, Stack } from '@ff-it/ui';
import { InvoiceStateTag } from 'modules/invoicing/common/InvoiceStateTag';

import { previewBtn, previewDialog, previewIframe } from './style.css';

export function Nav(): ReactElement {
  const { item } = useEntity<Expense>();
  const nav = useNavLinks(item, permissions);
  const {
    state,
    partner,
    number,
    sums: { paym_state },
  } = item;

  return (
    <div className="container-fluid header header--expense">
      <div className="d-flex flex-row align-items-center my-2">
        <h2 className="mt-0">
          <InvoiceSource {...item} className="mr-1" />
          <strong>{partner.title}</strong>
          <small className="text-muted ml-2">
            #{number} <PaymentStateBadge state={paym_state} />
          </small>
        </h2>
        <InvoiceStateTag state={state} size="sm" className="ml-2" />

        <ButtonGroup ml="2">
          {item.attachments?.map(({ file, filename, id }) => (
            <Dialog key={id}>
              <DialogTrigger>
                <Button size="xs" variant="secondary" icon="file">
                  <Box className={previewBtn}>{filename}</Box>
                </Button>
              </DialogTrigger>
              <DialogContent className={previewDialog} p="0">
                {/*  <a key={id} href={file} target="_blank" rel="noopener noreferrer" */}
                <iframe title="file" src={file} className={previewIframe} />
              </DialogContent>
            </Dialog>
          ))}
        </ButtonGroup>

        {state !== 'CANCELED' && item.can_book && (
          <Stack direction="horizontal" marginLeft="auto">
            <EntityActions actions={bookingActions} />
          </Stack>
        )}
      </div>
      <TabNav nav={nav} />
    </div>
  );
}
